import React, { FunctionComponent } from "react";
import classNames from "classnames";
import Popover, { PopoverClassKey, PopoverProps } from "@mui/material/Popover";

import "../../../css/filter_bar/filter_bar_flyout.css";

export type Props = {
  className?: string
  ModalClasses?: Partial<Record<PopoverClassKey, string>>
  children: React.ReactNode
  open: boolean
} & PopoverProps

const FilterBarFlyout: FunctionComponent<Props> = function FilterBarFlyout(props) {
  const {
    /* Overridden props */
    className,
    marginThreshold,
    PaperProps,
    ModalClasses,
    classes,
    /* Required props */
    open,
    children,
    /* Default value props */
    anchorOrigin,
    transformOrigin,
    /* Passed through props */
    ...otherProps
  } = props;

  return <Popover
    classes={ModalClasses}
    open={open}
    anchorOrigin={anchorOrigin}
    transformOrigin={transformOrigin}
    marginThreshold={8}
    PaperProps={{
      square: true,
      classes: { root: classNames("FilterBarFlyout", className) }
    }}
    {...otherProps}
  >
    {children}
  </Popover>;
}

FilterBarFlyout.defaultProps = {
  anchorOrigin: { vertical: "bottom", horizontal: "left" },
  transformOrigin: { vertical: "top", horizontal: "left" }
};

export default React.memo(FilterBarFlyout);
